'use strict';

angular.module('substoreApp.controllers')
    .controller('myproductsController', MyproductsController);

function MyproductsController($scope, $routeParams, dialogData, sessionData, uiservice, productDataCollector, htmlTruster, webtrekk) {

    $scope.isMyProductsActive = true;

    $scope.breadcrumb.init("navigation_myproducts");

    $scope.footnotes = [];

    sessionData.deleteCurrentSubscription();

    var allFootnotes = [];

    var limitedFootnotes = null;
    var limitedToSubscriptionTemplateId = $routeParams.subscriptionTemplateId || null;

    function configureGrouping(productList) {
        for (var p = 0; p < productList.length; p++) {
            var product = productList[p];

            product.isSingleOption = (product.productOptions.length === 1);
            product.productOptions[0].isFirstOption = true;
            product.productOptions[(product.productOptions.length - 1)].isLastOption = true;
        }
    }

    function getDialogData() {
        return uiservice.myProductsOverviewDialogData({sessionId: sessionData.sessionId},
            function success(response) {
                initDialogData(response.data);
            },
            $scope.throwServiceResponseFault
        ).$promise;
    }

    function initDialogData(data) {
        data = data || dialogData;

        $scope.footnotes = [];

        data.visibleProductList = (limitedToSubscriptionTemplateId ? [] : data.productList);

        var limitedToProduct = null;

        var productsCount = data.productList.length;
        for (var p = 0; p < productsCount; p++) {

            var product = productDataCollector.collect(data.productList[p]);

            for (var i = 0; i < product.productDescription.footnotes.length; i++)
                allFootnotes.push(product.productDescription.footnotes[i]);

            if (limitedToSubscriptionTemplateId && limitedToSubscriptionTemplateId === product.subscriptionTemplateId) {
                data.visibleProductList.push(product);

                for (var o = 0; o < product.productOptions.length; o++)
                    product.productOptions[o].isDetailsExpanded = true;

                limitedFootnotes = [];
                for (var i = 0; i < product.productDescription.footnotes.length; i++)
                    limitedFootnotes.push(product.productDescription.footnotes[i]);

                limitedToProduct = product;
            }

            // because template properties do not match to implemented action keys, we give each product a translation map
            product.actionLabels = {
                "myproducts_btn_cancel": product.texts.orderCancellationButtonLabel,
                "myproducts_btn_termination": product.texts.orderTerminationButtonLabel,
                "myproducts_btn_reservationTermination": product.texts.orderReservationDeletionButtonLabel,
                "myproducts_btn_reactivation": product.texts.orderReactivationButtonLabel,
                "myproducts_btn_productChange": product.texts.productChangeButtonLabel,
                "myproducts_btn_finalize": product.texts.orderFinalisationButtonLabel,
                "myproducts_btn_administration": product.texts.orderAdministrationButtonLabel,
                "myproducts_btn_resume": product.texts.orderReservationFinalisationButtonLabel,
                "myproducts_btn_optin": product.texts.orderOptinButtonLabel,
                "myproducts_prompt_cancel": product.texts.orderCancellationQuestion,
                "myproducts_prompt_cancel_date": product.texts.orderCancellationDateQuestion,
                "myproducts_prompt_termination": product.texts.orderTerminationQuestion,
                "myproducts_prompt_reservationTermination": product.texts.orderReservationDeletionQuestion,
                "myproducts_prompt_reactivation": product.texts.orderReactivationQuestion,
                "myproducts_succeeded_cancel": product.texts.orderCancellationSucceeded,
                "myproducts_succeeded_termination": product.texts.orderTerminationSucceeded,
                "myproducts_succeeded_reservationTermination": product.texts.orderReservationDeletionSucceeded,
                "myproducts_succeeded_reactivation": product.texts.orderReactivationSucceeded
            };
        }

        $scope.footnotes = limitedFootnotes || allFootnotes;

        configureGrouping(data.productList);

        $scope.data = data;

        htmlTruster.trust($scope.data.visibleProductList);

        if (limitedToProduct)
            $scope.updateTeaser(
                limitedToProduct.texts.headerTitleMyProducts,
                limitedToProduct.texts.headerSubTitleMyProducts,
                limitedToProduct.images.headerImageMyProductsResourcePath);
        else
            $scope.updateTeaser();
    }

    // some helper functions

    function findProduct(subscriptionTemplateId, gracefully) {
        var productList = $scope.data.productList;
        for (var p = 0; p < productList.length; p++)
            if (productList[p].subscriptionTemplateId === subscriptionTemplateId)
                return productList[p];

        if (gracefully)
            return null;

        throw "cannot find product " + subscriptionTemplateId;
    }

    function findProductOption(subscriptionTemplateId, uniqueSubscriptionId, gracefully) {
        var product = findProduct(subscriptionTemplateId, gracefully);
        if (product) {
            var optionList = product.productOptions;
            for (var o = 0; o < optionList.length; o++)
                if (optionList[o].uniqueSubscriptionId == uniqueSubscriptionId)
                    return optionList[o];
        }

        if (gracefully)
            return null;

        throw "cannot find product option " + subscriptionTemplateId + "/" + uniqueSubscriptionId;
    }

    function getCollapseStates() {
        var states = {};
        for (var p = 0; p < $scope.data.productList.length; p++) {
            var product = $scope.data.productList[p];
            for (var o = 0; o < product.productOptions.length; o++) {
                var option = product.productOptions[o];

                states[option.uniqueSubscriptionId] = option.isDetailsExpanded;
            }
        }

        return states;
    }

    function applyCollapseStates(states) {
        for (var p = 0; p < $scope.data.productList.length; p++) {
            var product = $scope.data.productList[p];
            for (var o = 0; o < product.productOptions.length; o++) {
                var option = product.productOptions[o];

                option.isDetailsExpanded = states[option.uniqueSubscriptionId];
            }
        }
    }

    function forceExpand(uniqueSubscriptionId) {
        for (var p = 0; p < $scope.data.productList.length; p++) {
            var product = $scope.data.productList[p];
            for (var o = 0; o < product.productOptions.length; o++) {
                var option = product.productOptions[o];

                if (uniqueSubscriptionId === option.uniqueSubscriptionId) {
                    option.isDetailsExpanded = true;
                    return;
                }
            }
        }
    }

    function hideButtons(productOption) {
        for (var attribute in productOption)
            if (productOption.hasOwnProperty(attribute) && attribute.indexOf("Allowed", attribute.length - 7) !== -1)
                productOption[attribute] = false;
    }

    // configure actions

    $scope.actions = {
        inProgress: { },
        succeeded: { },
        // service actions are those which require a call to the MyProduct action service on server.
        serviceActions: {
            reactivation: "reactivate",
            termination: "terminate",
            reservationTermination: "terminateReservation",
            orderDeletion: "terminateReservation",
            optin: "optin"
        },
        // routes for actions which start a navigation to another location
        routes: {
            "resume": "/orderselection/:subscriptionTemplateId",
            "productChange": "/productchangeselection/:subscriptionTemplateId/:uniqueSubscriptionId",
            "administration": "/orderadministrationselection/:subscriptionTemplateId/:uniqueSubscriptionId",
            "finalize": "/orderselection/:subscriptionTemplateId",
            "optin": function (subscriptionTemplateId, uniqueSubscriptionId) {
                // call MyProducts action "optin" on server to generate a new orderCallId,
                // then go to order summary with the new orderCallId (order summary _requires_ it)
                $scope.actions.invoke("optin", subscriptionTemplateId, uniqueSubscriptionId);
            }
        },
        invoke: function (action, subscriptionTemplateId, uniqueSubscriptionId) {
            action = (this.serviceActions[action] ? this.serviceActions[action] : action);

            var callback = function () {
                uiservice.myProductsAction({
                        sessionId: sessionData.sessionId,
                        uniqueSubscriptionId: uniqueSubscriptionId,
                        action: action
                    },
                    function success(response) {
                        // special case "optin": go to ordersummary afterwards
                        if (action === "optin") {
                            $scope.go("/ordersummary/" + subscriptionTemplateId + "/" + response.data.orderCallId + "/optin");
                            return;
                        }
                        // save option and position targeted by last action
                        var targetedProduct = findProduct(subscriptionTemplateId);
                        var targetedOption = findProductOption(subscriptionTemplateId, uniqueSubscriptionId);
                        var targetedProductPos = $scope.data.productList.indexOf(targetedProduct);

                        var collapseStates = getCollapseStates();

                        getDialogData().then(function () {
                            applyCollapseStates(collapseStates);

                            // enrich loaded options with option targeted by last action, as necessary
                            var actualProduct = findProduct(subscriptionTemplateId, true);
                            if (actualProduct) {
                                var actualOption = findProductOption(subscriptionTemplateId, uniqueSubscriptionId, true);
                                if (!actualOption) {
                                    actualProduct.productOptions.splice(targetedProduct.productOptions.indexOf(targetedOption), 0, targetedOption);
                                    hideButtons(targetedOption);
                                }
                            } else {
                                $scope.data.productList.splice(targetedProductPos, 0, targetedProduct);
                                hideButtons(targetedOption);
                            }

                            configureGrouping($scope.data.productList);

                            // handle new states
                            $scope.actions.succeeded[uniqueSubscriptionId] = $scope.actions.inProgress[uniqueSubscriptionId];
                            $scope.actions.inProgress[uniqueSubscriptionId] = {};
                        });
                    },
                    $scope.throwServiceResponseFault
                );
            };

            /*if ($.inArray(action, ['cancel', 'termination', 'reactivation', 'reservationTermination', 'orderDeletion']) !== -1) {
                webtrekk.track('myproducts_confirmation_' + action.toLowerCase(), {shop_product_sku: subscriptionTemplateId}).promise.then(callback);
            } else {
                callback();
            }*/
            callback();

        },
        go: function (action, subscriptionTemplateId, uniqueSubscriptionId) {
            var route = this.routes[action];
            if (route instanceof Function) {
                route(subscriptionTemplateId, uniqueSubscriptionId);
            } else {
                // replace placeholders in path, if any
                var path = route.replace(/:subscriptionTemplateId/g, subscriptionTemplateId)
                                .replace(/:uniqueSubscriptionId/g, uniqueSubscriptionId);
                $scope.go(path);
            }
        },
        isLocalAction: function (action) {
            return this.routes[action] == undefined;
        },
        isInProgress: function (action, uniqueSubscriptionId) {
            return (this.inProgress[uniqueSubscriptionId] ? this.inProgress[uniqueSubscriptionId][action] : false);
        },
        isSucceeded: function (action, uniqueSubscriptionId) {
            return (this.succeeded[uniqueSubscriptionId] ? this.succeeded[uniqueSubscriptionId][action] : false);
        },
        isSomethingInProgress: function (uniqueSubscriptionId) {
            var flags = this.inProgress[uniqueSubscriptionId];
            if (!flags) {
                return false;
            }
            for (var flag in flags) {
                if (flags[flag]) {
                    return true;
                }
            }
            return false;
        },
        promptArgs: function (action, productOption) {
            if (action === 'cancel')
                return { 'cancellationDate': productOption.cancellationDate }
            else
                return {};
        },
        toggleInProgress: function (action, uniqueSubscriptionId, subscriptionTemplateId) {
            var flags = this.inProgress[uniqueSubscriptionId];
            if (!flags) {
                flags = this.inProgress[uniqueSubscriptionId] = {};
            }

            flags[action] = !flags[action];

            if (flags[action]) {
                //webtrekk.track('myproducts_confirmation_' + action.toLowerCase(), {shop_product_sku: subscriptionTemplateId});

                forceExpand(uniqueSubscriptionId);
            }

            for (var flag in flags)
                if (flag !== action)
                    flags[flag] = false;
        }
    };

    // only for limited view: show all products
    $scope.showAllProducts = function() {
        $scope.go("/myproducts");
    };

    initDialogData();

    webtrekk.track('myproducts_overview', {});
}
